export default "__VITE_ASSET__BMl_1HR___"